module.exports = __webpack_public_path__ + "static/media/revlon2.b2d7c7b6.png";